<!-- wizard-modal.component.html -->
<nb-card [nbSpinner]="isLoading" [nbSpinnerMessage]="loadingMessage" class="wizard-card">
  <nb-card-header class="wizard-header">
    <div class="header-content">
      <h3>{{ getStepTitle() }}</h3>
      <nb-icon icon="close-outline" (click)="close()" class="close-icon"></nb-icon>
    </div>
  </nb-card-header>

  <nb-card-body>
    <ng-container *ngIf="!isLoading" [ngSwitch]="currentStep">
      <!-- STEP 0: General -->
      <form *ngSwitchCase="0" [formGroup]="campaignConfiguration">
        <div class="form-group">
          <div class="row">
            <div class="col">
              <label i18n>Campaign Name<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <input
                ngbAutofocus
                class="form-control form-control-sm"
                type="text"
                placeholder="Campaign Name"
                i18n-placeholder
                formControlName="campaignName"
                required
                nbInput
                style="width: 100%"
              />
            </div>
          </div>
          <div *ngIf="campaignConfiguration.get('campaignName').hasError('pattern')">
            <p i18n>
              The first character must be alphanumeric, and up to 128 letters (uppercase and lowercase), numbers,
              hyphens, and underscores are allowed.
            </p>
          </div>
          <br />
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col"><label i18n>Description:</label></div>
            <div class="col-9">
              <textarea
                nbInput
                placeholder="Description"
                i18n-placeholder
                style="width: 100%"
                formControlName="campaignDescription"
              ></textarea>
            </div>
          </div>
          <br />
        </div>
        <div *ngIf="envName !== 'stage'" class="form-group">
          <div class="row">
            <div class="col">
              <label i18n>Start Time<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <div class="picker-row">
                <input
                  id="start"
                  nbInput
                  formControlName="startDate"
                  [owlDateTime]="startPicker"
                  [min]="minStartDate"
                  [owlDateTimeTrigger]="startPicker"
                  (dateChange)="changeEvent()"
                  placeholder="Select Start Time"
                  i18n-placeholder
                />
                <owl-date-time #startPicker></owl-date-time>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div *ngIf="envName !== 'stage'" class="form-group">
          <div class="row">
            <div class="col">
              <label i18n>End Time<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <div class="picker-row">
                <input
                  id="end"
                  nbInput
                  formControlName="endDate"
                  [owlDateTime]="endPicker"
                  [owlDateTimeTrigger]="endPicker"
                  [min]="minEndDate"
                  placeholder="Select End Time"
                  i18n-placeholder
                />
                <owl-date-time #endPicker></owl-date-time>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div *ngIf="type !== 'mc'">
            <div class="row">
              <nb-toggle labelPosition="start" formControlName="prime" i18n>Prime Campaign</nb-toggle>
            </div>
          </div>
          <br />
          <div class="row">
            <nb-toggle labelPosition="start" formControlName="non_localization_campaign" i18n>
              Non-localization Campaign
            </nb-toggle>
          </div>
          <p *ngIf="campaignConfiguration?.get('non_localization_campaign').value">
            <i i18n>
              Non-localization campaigns will use plaintext provided in content for the message. No
              translation/localization available for this type of message. In case of a typo or wrong user segmentation
              -
              <a
                href="https://irobot.atlassian.net/wiki/spaces/HKC/pages/5176623329/How+to+recall+Insight+Engine+messages"
              >
                recall
              </a>
              will be needed.
            </i>
          </p>
          <br />
        </div>
      </form>

      <!-- STEP 1: Trigger -->
      <form *ngSwitchCase="1" [formGroup]="triggerConfiguration">
        <div class="form-group">
          <div class="row">
            <div class="col">
              <label i18n>Trigger Query<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <!-- <p>
                    <i
                      >Press F11 when cursor is in the editor to toggle full screen
                      editing. F11 can also be used to exit full screen editing.</i
                    >
                  </p>
                  <br /> -->
              <ngx-codemirror
                #codeeditor
                id="query"
                name="query"
                formControlName="query"
                [options]="{
                  lineNumbers: true,
                  theme: 'default',
                  mode: 'sql'
                }"
              ></ngx-codemirror>
            </div>
          </div>
        </div>
      </form>

      <!-- STEP 2: Content -->
      <form *ngSwitchCase="2" [formGroup]="contentConfiguration">
        <div *ngIf="type !== 'so'">
          <div class="row">
            <div class="col">
              <label i18n>Category Icon ID<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <nb-select
                placeholder="Category Icon ID"
                i18n-placeholder
                fullWidth
                style="width: 90%"
                formControlName="category_icon_id"
                id="category_icon_id.id"
                name="content.category_icon_id"
                (selectedChange)="onSelectionChange($event)"
              >
                <nb-option *ngFor="let category of categoryIconId" [value]="category">
                  {{ category | replaceunderscore | titlecase }}
                </nb-option>
              </nb-select>
            </div>
          </div>
          <br />
        </div>
        <div class="row">
          <div class="col">
            <label i18n>Category Title Text<span style="color: red">*</span>:</label>
          </div>
          <div class="col-9">
            <nb-select
              placeholder="Category Title Text"
              i18n-placeholder
              fullWidth
              style="width: 90%"
              id="category_title_text"
              name="category_title_text"
              formControlName="category_title_text"
              (selectedChange)="onCategoryTitleSelect($event)"
            >
              <nb-option *ngFor="let category of filteredTitles" [value]="category.text">
                {{ category.text | replaceunderscore | titlecase }}
              </nb-option>
            </nb-select>
          </div>
        </div>
        <br />

        <div *ngIf="!campaignConfiguration?.get('non_localization_campaign').value">
          <div class="row">
            <div class="col">
              <label i18n>Headline Text ID<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <ng-select
                placeholder="Text ID"
                i18n-placeholder
                formControlName="headline_text_id"
                style="width: 90%"
                [addTag]="addTag"
              >
                <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                  {{ drbID }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <br />
        </div>
        <div *ngIf="campaignConfiguration?.get('non_localization_campaign').value">
          <div class="row">
            <div class="col">
              <label i18n>Headline Text<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <input
                ngbAutofocus
                class="form-control form-control-sm"
                type="text"
                placeholder="Headline Text"
                i18n-placeholder
                formControlName="headline_text"
                required
                nbInput
                style="width: 100%"
              />
            </div>
          </div>
          <br />
        </div>
        <div class="row">
          <div class="col">
            <label i18n>Action Button</label>
          </div>
          <div class="col-9">
            <nb-checkbox
              ngDefaultControl
              (checkedChange)="toggleActionValidators($event)"
              formControlName="action_button"
              name="action_button"
            ></nb-checkbox>
          </div>
        </div>
        <br />
        <div *ngIf="contentConfiguration?.get('action_button').value">
          <div *ngIf="campaignConfiguration?.get('non_localization_campaign').value">
            <div class="row">
              <div class="col">
                <label i18n>Button Text<span style="color: red">*</span>:</label>
              </div>
              <div class="col-9">
                <input
                  ngbAutofocus
                  class="form-control form-control-sm"
                  type="text"
                  placeholder="Button Text"
                  i18n-placeholder
                  formControlName="text"
                  required
                  nbInput
                  style="width: 100%"
                />
              </div>
            </div>
            <br />
          </div>
          <div *ngIf="!campaignConfiguration?.get('non_localization_campaign').value" class="row">
            <div class="col">
              <label i18n>Button Text ID<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <ng-select
                placeholder="Text ID"
                i18n-placeholder
                formControlName="text_id"
                style="width: 90%"
                [addTag]="addTag"
              >
                <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                  {{ drbID }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <br />
          <div *ngIf="campaignConfiguration?.get('non_localization_campaign').value">
            <div class="row">
              <div class="col">
                <label i18n>Destination URI<span style="color: red">*</span>:</label>
              </div>
              <div class="col-9">
                <input
                  ngbAutofocus
                  class="form-control form-control-sm"
                  type="text"
                  placeholder="Destination URI"
                  i18n-placeholder
                  formControlName="destination_uri"
                  required
                  nbInput
                  style="width: 100%"
                />
              </div>
            </div>
            <br />
          </div>
          <div *ngIf="!campaignConfiguration?.get('non_localization_campaign').value" class="row">
            <div class="col">
              <label i18n>Destination URI ID<span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <ng-select
                placeholder="Destination URI ID"
                i18n-placeholder
                style="width: 90%"
                formControlName="destination_uri_id"
                [addTag]="addTag"
              >
                <ng-option *ngFor="let drbID of drbIds.link" [value]="drbID">
                  {{ drbID }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <br />

          <div class="row">
            <div class="col">
              <label i18n>Destination Type <span style="color: red">*</span>:</label>
            </div>
            <div class="col-9">
              <nb-select
                placeholder="Select Destination Type"
                i18n-placeholder
                formControlName="destination_type"
                style="width: 90%"
              >
                <nb-option *ngFor="let destination_type of destinationTypes" [value]="destination_type.value">
                  {{ destination_type.label | replaceunderscore | titlecase }}
                </nb-option>
              </nb-select>
            </div>
          </div>
        </div>
        <br />

        <div class="row" *ngIf="type === 'ct'">
          <div class="col">
            <label i18n>Modal Show Page <span style="color: red">*</span>:</label>
          </div>
          <div class="col-9">
            <div *ngIf="!campaignConfiguration.get('prime')?.value; else prime">
              <nb-select
                placeholder="Select Modal Show Page"
                i18n-placeholder
                formControlName="active_parent_uri_id"
                style="width: 90%"
              >
                <nb-option *ngFor="let uri of activeParentUriList" [value]="uri.value">
                  {{ uri.label }}
                </nb-option>
              </nb-select>
            </div>
            <ng-template #prime>
              <nb-select
                placeholder="Select Modal Show Page"
                i18n-placeholder
                formControlName="active_parent_uri_id"
                style="width: 90%"
              >
                <nb-option *ngFor="let uri of primeUriList" [value]="uri.value">
                  {{ uri.label }}
                </nb-option>
              </nb-select>
            </ng-template>
          </div>
        </div>
        <br />

        <ng-container>
          <h5 i18n>Message Payload</h5>
          <i style="color: gray" i18n>
            Drag and drop to decide the order of text/HTML/image (first will be shown on top, last on bottom)
          </i>
          <br />
          <br />
          <div
            *ngIf="!campaignConfiguration?.get('non_localization_campaign').value"
            formArrayName="payload"
            cdkDropList
            [cdkDropListData]="payload.controls"
            class="example-list"
            (cdkDropListDropped)="drop($event)"
          >
            <nb-icon cdkDragHandle icon="menu-2-outline" class="drag-handle" aria-label="Drag handle"> </nb-icon>
            <div
              *ngFor="let grp of payload.controls; let i = index; trackBy: trackByPayloadKey"
              [formGroupName]="i"
              cdkDrag
              class="example-box"
            >
              <ng-container *ngIf="!(type === 'ct' && grp.value.key === 'Content HTML ID')">
                <label>{{ grp.value.key }}</label>
                <ng-container [ngSwitch]="grp.value.key">
                  <ng-select
                    *ngSwitchCase="'Content Image ID'"
                    formControlName="id"
                    fullWidth
                    style="width: 90%"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.image" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                  <ng-select
                    *ngSwitchCase="'Content HTML ID'"
                    formControlName="id"
                    fullWidth
                    style="width: 90%"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                  <ng-select
                    *ngSwitchCase="'Content Text ID'"
                    formControlName="id"
                    fullWidth
                    style="width: 90%"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <div
            *ngIf="campaignConfiguration?.get('non_localization_campaign').value"
            formArrayName="payload"
            cdkDropList
            [cdkDropListData]="payload.controls"
            class="example-list"
            (cdkDropListDropped)="drop($event)"
          >
            <nb-icon cdkDragHandle icon="menu-2-outline" class="drag-handle" aria-label="Drag handle"> </nb-icon>
            <div
              *ngFor="let grp of payload.controls; let i = index; trackBy: trackByPayloadKey"
              [formGroupName]="i"
              cdkDrag
              class="example-box"
            >
              <label>{{ grp.value.key }}</label>
              <input type="text" formControlName="id" nbInput style="width: 90%" />
            </div>
          </div>
        </ng-container>
        <div *ngIf="['ct', 'so'].includes(type)" class="p-2">
          <button
            nbButton
            status="info"
            [disabled]="!marketing.version || !marketing_translations.version"
            (click)="previewContent()"
            [nbSpinner]="!marketing.version || !marketing_translations.version"
            nbSpinnerStatus="info"
            i18n
          >
            Preview Content
          </button>
        </div>
        <br />
      </form>

      <!-- STEP 3: Recap and Create -->
      <div *ngSwitchCase="3" class="recap-container">
        <h4 i18n>General Configuration</h4>
        <ul>
          <li><strong i18n>Name:</strong> {{ campaignConfiguration.value.campaignName }}</li>
          <li><strong i18n>Description:</strong> {{ campaignConfiguration.value.campaignDescription }}</li>
          <li>
            <strong i18n>Campaign will start at:</strong>
            {{ campaignConfiguration.value.startDate | date: 'long' }}
          </li>
          <li>
            <strong i18n>Campaign will end at:</strong>
            {{ campaignConfiguration.value.endDate | date: 'long' }}
          </li>
          <li><strong i18n>Campaign cadance:</strong> Every Day</li>
          <li><strong i18n>Resend buffer:</strong> 365 Days</li>
        </ul>

        <h4 i18n>Content Configuration</h4>
        <ul>
          <li *ngIf="type === 'so'">
            <strong i18n>Category:</strong> {{ contentConfiguration.value.category_title_text }}
          </li>
          <li *ngIf="type === 'so'">
            <strong i18n>Headline Text ID:</strong> {{ contentConfiguration.value.headline_text_id }}
          </li>
          <li *ngIf="contentConfiguration.value.action_button" i18n>
            <strong>Action Button:</strong> Yes
            <ul *ngIf="!campaignConfiguration?.get('non_localization_campaign').value">
              <li>Button Text ID: {{ contentConfiguration.value.text_id }}</li>
              <li>Destination URI ID: {{ contentConfiguration.value.destination_uri_id }}</li>
              <li>Destination Type: {{ contentConfiguration.value.destination_type }}</li>
            </ul>
            <ul *ngIf="campaignConfiguration?.get('non_localization_campaign').value">
              <li>Button Text: {{ contentConfiguration.value.text }}</li>
              <li>Destination URI: {{ contentConfiguration.value.destination_uri }}</li>
              <li>Destination Type: {{ contentConfiguration.value.destination_type }}</li>
            </ul>
          </li>
          <li>
            <strong i18n>Payload Order:</strong>
            <ol>
              <ol>
                <ng-container *ngIf="type !== 'ct'; else ct">
                  <li *ngFor="let p of payload.controls" i18n>{{ p.value.key }} (ID: {{ p.value.id }})</li>
                </ng-container>
                <ng-template #ct>
                  <ng-container *ngFor="let p of payload.controls">
                    <li *ngIf="p.value.key !== 'Content HTML ID'" i18n>{{ p.value.key }} (ID: {{ p.value.id }})</li>
                  </ng-container>
                </ng-template>
              </ol>
            </ol>
          </li>
        </ul>
      </div>
      <!-- STEP 4: QA TESTING -->
      <div *ngSwitchCase="4">
        <app-qa-testing></app-qa-testing>
      </div>
      <!-- STEP 4: Promotion-->
      <div *ngSwitchCase="5">
        <app-campaign-promotion-component
          [title]="'Promote'"
          [campaign]="createdCampaign"
          [campaign_trigger]="createdInsight"
          [content]="createdContent"
          [username]="username"
        ></app-campaign-promotion-component>
      </div>
      <div *ngSwitchCase="6">
        <div class="final-container">
          <div class="final-message">
            <span class="check">&check;</span>
            <span i18n>Complete</span>
          </div>
        </div>
      </div>
      <div *ngIf="showErrorMessage">
        <p style="color: red">
          <i>{{ loadingMessage }}</i>
        </p>
        <p style="color: red">
          <i i18n>Verify that all fields are set correctly, if the issue persists notify the team.</i>
        </p>
      </div>
    </ng-container>
  </nb-card-body>

  <nb-card-footer *ngIf="!isLoading" class="d-flex justify-content-between">
    <button nbButton status="basic" (click)="previous()" [disabled]="currentStep === 0 || currentStep >= 4" i18n>
      Previous
    </button>
    <button nbButton status="primary" [disabled]="getCurrentForm().invalid" (click)="next()" [ngSwitch]="currentStep">
      <div *ngSwitchCase="6" i18n>Finish</div>
      <div *ngSwitchCase="5" i18n>Skip Promotion</div>
      <div *ngSwitchCase="3" i18n>Create</div>
      <div *ngSwitchDefault i18n>Next</div>
    </button>
  </nb-card-footer>
</nb-card>
